var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 53,
    viewBox: "0 0 38 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M3.27551 46.2887C3.27551 49.9951 6.20589 53 9.82957 53H28.1697C31.7893 53 34.7238 49.9951 34.7238 46.2887V14.0885H3.27551V46.2887ZM37.9996 8.05053C37.9996 6.1978 36.5322 4.69609 34.7183 4.69609H26.8618V3.35024C26.8618 1.49991 25.3967 0 23.5846 0H14.4151C12.6048 0 11.1378 1.49848 11.1378 3.35024V4.69609H3.28136C1.46887 4.69609 0 6.20152 0 8.05053V11.405H38L37.9996 8.05053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.685fe01048f0279f8826c4eb20ef724a.svg";
export { ForwardRef as ReactComponent };